<div class="alert alert-light mb-0" role="alert">
    <div class="mr-1">
        <span i18n="@@ios-install-txt-1">Install {{title}} on your device. Tap</span><i class="ms-Icon ms-Icon--ShareiOS ml-1 mr-1" aria-hidden="true"></i><span i18n="@@ios-install-txt-2">and then "Add to homescreen".</span>
    </div>
    <button mat-icon-button aria-label="Close" class="small close-btn" (click)="close()">
        <i class="ms-Icon ms-Icon--ChromeClose small" aria-hidden="true"></i>
    </button>
</div>
